/**
 * Hook chamado UMA vez pelo app-core (`ui/modules.tsx`): liga o carregamento
 * das cotas e adiciona a camada ao mapa quando ele existir.
 */
import { createElement, useEffect } from 'react';
import { useMapInstance } from '../map/mapContext';
import { createRiverLayer } from './layer';
import { RiverPopup } from './RiverPopup';
import { startRiverSync } from './sync';

export { refreshRios } from './sync';

export function useRiverLayers(): void {
  const map = useMapInstance((s) => s.map);

  useEffect(() => startRiverSync(), []);

  useEffect(() => {
    if (!map) return;
    const { layer, dispose } = createRiverLayer((dado) => createElement(RiverPopup, { dado }));
    map.addLayer(layer);
    return () => {
      map.removeLayer(layer);
      dispose();
    };
  }, [map]);
}
